import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getDonorSummaryReport = get(
  'inventory.components.reports.donorSummary'
);

export const getDonorSummaryReportSearchQuery = createSelector(
  getDonorSummaryReport,
  get('searchQuery')
);
